export type CategoryKey =
  | 'office'
  | 'digitalPresence'
  | 'security'
  | 'automation'

export const CATEGORY_CONFIG: Record<CategoryKey, string[]> = {
  // office: [
  //   '77752196-ce71-4a95-b2d2-2c328f6b87d4', // primeiro - uuid dev
  //   '33c8baa5-ad2d-4da6-9893-be6c81c68841', // segundo - uuid prod
  // ],
  // cloud: [
  //   'ddd3a85b-f0e9-4055-841b-798b78f0f195',
  //   '99f86072-04fe-4634-9f8b-7c66cc7bb28e',
  // ],
  // business: [
  //   'd6130c15-ccb2-4140-933d-570eec976728',
  //   '99428efb-479c-4bd7-bdce-78a4edf9a000',
  // ],
  office: [
    '584da318-99f2-4ee7-8f36-9d11be301c51', // primeiro - uuid dev
    '45f7de28-6d4d-4607-8ff1-51729279e100', // segundo - uuid prod
  ],
  digitalPresence: [
    'e67a48c3-92a0-47ce-ac7b-f84fb827b269',
    '183cb010-545c-41e8-9311-225b26b42fdd',
  ],
  security: [
    '6ec7ae98-35ef-41cb-8835-c5057a63b5e9',
    '7a4eeafc-3d63-42d7-b067-ae0de63e714c',
  ],
  automation: [
    '2f63f39c-092a-4754-a8c3-ff7a244e53d3',
    // '7a4eeafc-3d63-42d7-b067-ae0de63e714c',
  ],
};

export const CATEGORY_ORDER: CategoryKey[] = [
  // 'business',
  // 'cloud',
  'office',
  'digitalPresence',
  'security',
  'automation',
];